function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.0659 36.2161C75.0659 35.513 75.6933 34.9403 76.4637 34.9403C77.2381 34.9403 77.8616 35.5091 77.8616 36.2161C77.8616 36.9191 77.2341 37.4919 76.4637 37.4919C75.6933 37.4879 75.0659 36.9191 75.0659 36.2161Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.11261 33.6605H4.98372C5.64292 33.6605 6.34978 33.8541 6.34978 34.6322C6.34978 35.3826 5.82559 35.588 4.85664 35.588H2.11261V33.6605ZM0.405029 38.9888H2.11261V36.5834H5.4404C7.27505 36.5834 8.06133 35.5999 8.06133 34.6361C8.06133 33.6171 7.41007 32.6731 5.41657 32.6731H0.405029V38.9888ZM16.7382 39.1666C20.1812 39.1666 21.5234 37.6104 21.5234 35.829C21.5234 34.0515 20.1772 32.4914 16.7382 32.4914C13.2952 32.4914 11.953 34.0476 11.953 35.829C11.953 37.6064 13.2952 39.1666 16.7382 39.1666ZM16.7382 38.1752C14.8241 38.1752 13.7281 37.2193 13.7281 35.829C13.7281 34.4386 14.8202 33.4828 16.7382 33.4828C18.6523 33.4828 19.7483 34.4386 19.7483 35.829C19.7483 37.2193 18.6523 38.1752 16.7382 38.1752ZM25.8718 38.9888H32.5273V37.9461H27.5793V32.6691H25.8718V38.9888ZM38.8771 36.4294L40.2909 33.7672L41.6807 36.4294H38.8771ZM35.6764 38.9888H37.523L38.3649 37.4208H42.193L43.0468 38.9888H44.949L41.3233 32.6691H39.2941L35.6764 38.9888ZM48.8168 38.9888H50.4569V34.2451H50.4807L55.3572 38.9888H57.2832V32.6691H55.6432V37.4129H55.6193L50.7746 32.6691H48.8129V38.9888H48.8168ZM63.7958 33.6605H66.111C67.068 33.6605 68.7438 33.783 68.7438 35.8369C68.7438 37.6854 67.4334 37.9974 66.2023 37.9974H63.7958V33.6605ZM62.0843 38.9888H66.8814C69.6493 38.9888 70.4474 37.2549 70.4474 35.8922C70.4474 34.0871 69.6612 32.6731 66.4684 32.6731H62.0803V38.9888H62.0843Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M83.1312 38.9888H88.4525C90.6525 38.9888 91.2204 37.8394 91.2204 37.1285C91.2204 36.066 90.3666 35.7144 89.7391 35.5604C90.172 35.4024 90.8431 35.1456 90.8431 34.2411C90.8431 33.4354 90.3626 32.6651 88.5081 32.6651H83.1272V38.9888H83.1312ZM84.8427 33.6605H87.7377C88.7305 33.6605 89.1395 33.9093 89.1395 34.4307C89.1395 35.1456 88.5121 35.2365 88.0355 35.2365H84.8427V33.6605ZM84.8427 36.1726H88.1586C88.9211 36.1726 89.4453 36.4807 89.4453 37.0653C89.4453 37.8789 88.6709 37.9935 87.9084 37.9935H84.8427V36.1726ZM98.1658 36.4293L99.5795 33.7671L100.969 36.4293H98.1658ZM94.9611 38.9888H96.8077L97.6496 37.4207H101.478L102.332 38.9888H104.234L100.608 32.6691H98.5788L94.9611 38.9888ZM108.237 38.9888H114.892V37.9461H109.948V32.6691H108.241V38.9888H108.237ZM120.066 38.9888H121.774V33.6605H124.828V32.6691H117.009V33.6605H120.063V38.9888H120.066ZM128.934 38.9888H130.642V32.6691H128.934V38.9888ZM144.112 35.0074C143.929 33.6447 142.471 32.4953 139.668 32.4953C136.467 32.4953 135.121 34.0515 135.121 35.8329C135.121 37.6103 136.523 39.1705 139.461 39.1705C142.813 39.1705 143.873 37.8355 144.112 36.5794H142.265C142.13 37.243 141.534 38.1831 139.759 38.1831C138.072 38.1831 136.9 37.2707 136.9 35.9514C136.9 34.3043 138.075 33.4907 139.648 33.4907C141.086 33.4907 142.098 34.0555 142.269 35.0113H144.112V35.0074Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M112.005 3.87479H109.932H107.978L97.3835 22.5694H101.017L103.682 17.7782H109.928H116.103L118.831 22.5694H122.469L112.005 3.87479ZM109.932 15.353H105.052L109.932 6.53303L114.805 15.353H109.932Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.587708 3.87479V22.6326H19.244L19.24 20.5628H3.44691V3.87479H0.587708Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.901 3.87479L13.9108 10.5026H16.0591L19.9588 3.87479H16.901Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4938 0.560883C35.4302 0.560883 35.3627 0.560883 35.2317 0.560883C28.2108 0.560883 21.4519 5.53373 21.4519 12.3985C21.4519 19.2634 27.3649 24.1138 35.2317 24.1138C35.3627 24.1138 35.4263 24.1138 35.4938 24.1138C44.7901 23.9953 49.4721 17.9599 49.4721 12.3985C49.4721 6.42244 44.5956 0.679378 35.4938 0.560883ZM35.4938 21.8031C35.4302 21.8031 35.3627 21.8031 35.2317 21.8031C29.9025 21.8031 24.8949 17.8967 24.8949 12.3946C24.8949 6.29605 30.8754 2.92684 35.2317 2.92684C35.3627 2.92684 35.4263 2.92684 35.4938 2.92684C42.7728 3.10458 46.0927 8.36971 46.0927 12.3946C46.0927 17.1265 41.4782 21.6846 35.4938 21.8031Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M68.3865 14.7605C68.3865 14.7605 73.5251 13.3978 73.5251 9.25841C73.5251 3.81554 67.1554 3.87478 67.1554 3.87478H53.2446V22.6326H56.1038V14.7605H64.6854L70.9915 22.5694H74.633L68.3865 14.7605ZM66.3056 12.5131H63.2479H56.0999V6.12224H63.2479H66.3056C66.3056 6.12224 70.3363 6.00375 70.3363 9.25841C70.3363 12.6908 66.3056 12.5131 66.3056 12.5131Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.812 3.87479V22.6326H143.468V20.6221H127.671V3.87479H124.812Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.7193 3.87479L78.7233 22.5694H96.9308V20.5628H81.8446V14.0496H93.2178V11.9167H81.8446V5.9445H96.9308V3.87479H78.7193Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.2853 0.797882H88.2103L85.8117 3.22308L93.2853 0.797882Z",
  fill: "black"
});

var SvgLoreal = function SvgLoreal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 40,
    viewBox: "0 0 146 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoreal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loreal.e3e3df97.svg";
export { ForwardRef as ReactComponent };